<template>
  <v-container class="registryservices">
    <PageHeader title="Manage Service Credentials" subtitle="Credentials are used to authenticate your Camunda process instances. Use a separate credential for
      each process instance. Credentials can only be viewed the first time they are generated." icon="assignment" />

    <Subheader title="Service Credentials" no-search>
      <v-btn :loading="isGeneratingCredential" @click="generateNewCredentials" color="success">
        <v-icon left>add</v-icon>
        {{$t('Button.GenerateNewCredentials')}}
      </v-btn>
    </Subheader>
    <v-layout mb-4 class="showauthentications">
      <PageLoader v-if="isLoading" resourceName="Service Credentials" />
      <ServiceCredentials v-else :serviceCredentials="serviceCredentials" />
    </v-layout>

    <div style="padding: 20px;">
      <div class="headline mb-4"> Client Id </div>
      <p>
        The Client Id is the same for all credentials. <br />
        <span v-if="!clientId">
          To view the Client Id, have at least one credential generated.
        </span>
      </p>
      <v-layout mt-5>
        <v-flex sm6 md4 lg3>
          <ItemTextField v-if="clientId" title="ClientId" :value="clientId" />
        </v-flex>
      </v-layout>

      <div class="headline mb-4"> Reset Client Id </div>
      <p>
        Only reset the Client Id if your credentials have been compromised. <br />
        All Camunda processes that use this Client Id must be updated.
      </p>
      <ConfirmationDialog :loading="isResettingCredentials" title="Reset Client Id" label="Reset Client Id" text="Are you sure you want to reset the client id? All Camunda process that use this client id must be updated." @submit="resetClientId" />
      <div>
        <v-icon :color="resetColor">{{ resetIcon }}</v-icon>
        <p style="display: inline-block; margin: 0 auto; margin-top: 10px;">{{ resetMessage }}</p>
      </div>
    </div>
  </v-container>
</template>

<script>
  import ConfirmationDialog from '../Helpers/ConfirmationDialog'

  import ItemTextField from './ItemTextField'
  import ServiceCredentials from './ServiceCredentials'

  export default {
    components: {
      ConfirmationDialog,
      ItemTextField,
      ServiceCredentials,
    },
    data() {
      return {
        isLoading: false,
        isGeneratingCredential: false,
        isResettingCredentials: false,
        resetMessage: '',
        resetIcon: '',
        resetColor: '',
      }
    },
    computed: {
      serviceCredentials() {
        return this.$store.getters['servicecredentials/serviceCredentials']
      },
      clientId() {
        if (this.serviceCredentials.length == 0) {
          return
        }

        return this.serviceCredentials[0].ClientId
      },
    },
    methods: {
      generateNewCredentials() {
        this.isGeneratingCredential = true
        this.$store.dispatch('servicecredentials/generateRefreshToken')
          .then(function() {
            this.isGeneratingCredential = false
          }.bind(this))
          .catch(function(error) {
            console.log(error)
            this.isGeneratingCredential = false
          }.bind(this))
      },
      getServiceCredentials() {
        this.isLoading = true
        this.$store.dispatch('servicecredentials/getRefreshTokens')
          .then(function() {
            this.isLoading = false
          }.bind(this))
          .catch(function() {
            this.isLoading = false
          }.bind(this))
      },
      resetClientId() {
        this.isResettingCredentials = true
        this.resetIcon = ''
        this.resetMessage = ''
        this.$store.dispatch('servicecredentials/resetClientId')
          .then(function() {
            console.log('here')
            this.isResettingCredentials = false
            this.resetMessage = 'Client id has been reset'
            this.resetIcon = 'done'
            this.resetColor = 'success'
            this.getServiceCredentials()
          }.bind(this))
          .catch(function(error) {
            console.log(error)
            this.isResettingCredentials = false
            this.resetMessage = 'Sorry, the client id could not be reset.'
            this.restIcon = 'close'
            this.restColor = 'error'
            this.getServiceCredentials()
          }.bind(this))
      },
    },
    created() {
      this.getServiceCredentials()
    },
  }
</script>